module.exports = __webpack_public_path__ + "static/media/tachometer-fastest.2b0c2c30.svg";